import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'pr-sum',
    templateUrl: './pr-sum.component.html',
    styleUrls: ['./pr-sum.component.scss'],
    standalone: false
})
export class PrSumComponent implements OnInit {
  @Input() label: string;
  @Input() etiquette: string;
  @Input() clazz: string;

  constructor() {}

  ngOnInit() {}
}
